import React from 'react'
import { TableRowComponent as TableRow } from "./TableRow";
import { NoRows } from "../../../../layout/Table/NoRows";

const TableBody = ({users, actionCallback}) => {

  if (!Array.isArray(users) || users.length === 0) {
    return (
      <tbody>
      <NoRows colspan="5"/>
      </tbody>
    )
  }

  return (
    <tbody>
    {
      users.map((user, index) => (
        <TableRow
          key={`user-+${user.id}`}
          index={index}
          user={user}
          actionCallback={actionCallback}
        />
      ))
    }
    </tbody>
  )
}

export {
  TableBody
}
